import View from '../../../Core/View.js';

class VideoPlayer extends View {

	initialize() {
		this.$startScreen = this.$el.find('.videoplayer__start-screen');
		this.$video = this.$el.find('.videoplayer__video');

		this.$startScreen.on('click', this._onTriggerClicked.bind(this));
	}

	_onTriggerClicked(event) {
		event.preventDefault();

		this.loadIFrame();
	}

	loadIFrame() {
		this.$video.attr('src', this.$video.data('src'));
		this.$el.addClass('videoplayer--triggered');

		setTimeout(this._onIFrameProbablyLoaded.bind(this), 1000);
	}

	_onIFrameProbablyLoaded() {
		this.$startScreen.remove();
	}
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./js/Views/Modules/VideoPlayer/VideoPlayer.js